import { render, staticRenderFns } from "./CDSFooter.vue?vue&type=template&id=fb3db88a"
import script from "./CDSFooter.vue?vue&type=script&lang=js"
export * from "./CDSFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports